import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../App';

const translations = {
  en: {
    message: 'We use cookies to enhance your browsing experience and analyze site traffic.',
    accept: 'Accept All',
    decline: 'Essential Only',
    learnMore: 'Cookie Policy'
  },
  tr: {
    message: 'Tarama deneyiminizi geliştirmek ve site trafiğini analiz etmek için çerezler kullanıyoruz.',
    accept: 'Tümünü Kabul Et',
    decline: 'Sadece Gerekli',
    learnMore: 'Çerez Politikası'
  },
  el: {
    message: 'Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία περιήγησής σας.',
    accept: 'Αποδοχή Όλων',
    decline: 'Μόνο Απαραίτητα',
    learnMore: 'Πολιτική Cookies'
  },
  de: {
    message: 'Wir verwenden Cookies, um Ihr Surferlebnis zu verbessern und den Website-Traffic zu analysieren.',
    accept: 'Alle Akzeptieren',
    decline: 'Nur Notwendige',
    learnMore: 'Cookie-Richtlinie'
  }
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const { language } = useContext(AppContext);
  const navigate = useNavigate();
  const t = translations[language] || translations.en;

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'all');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'essential');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t shadow-2xl p-4 md:p-6 animate-slide-up">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1 text-sm text-gray-700">
          <span>🍪 {t.message} </span>
          <button onClick={() => navigate('/cookie-policy')} className="text-[#C8A951] underline hover:text-[#B8941E] font-semibold">
            {t.learnMore}
          </button>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition font-medium"
          >
            {t.decline}
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm bg-[#C8A951] text-white rounded-lg hover:bg-[#B8941E] transition font-medium"
          >
            {t.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
